import { APP_STORE_URL, PLAY_STORE_URL } from '@/lib/constants/app-stores';
import { LICENSE_COMPANY } from '@/lib/constants/licenses';
import { absoluteUrl, getSiteOrigin } from '@/lib/seo/canonical-url';
import { MAIN_SEARCH_INDEX_ID } from '@/lib/services/typesense/constants';

const SAME_AS = [
  'https://blog.qualidoc.com.br/',
  'https://www.instagram.com/qualidoc/',
  APP_STORE_URL,
  PLAY_STORE_URL,
];

/**
 * Site-wide Organization + WebSite JSON-LD. Additive only — no UI.
 * Rendered from DefaultSeo so every public HTML response includes it.
 */
export default function OrganizationStructuredData() {
  const origin = getSiteOrigin();
  const siteUrl = absoluteUrl('/');
  const organizationId = `${origin}/#organization`;
  const jsonLd = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'MedicalOrganization',
        '@id': organizationId,
        name: 'Qualidoc',
        legalName: LICENSE_COMPANY.legalName,
        taxID: LICENSE_COMPANY.cnpj,
        url: siteUrl,
        logo: absoluteUrl('/logo.svg'),
        sameAs: SAME_AS,
        address: {
          '@type': 'PostalAddress',
          streetAddress: 'Alameda Barros, 136',
          addressLocality: 'São Paulo',
          addressRegion: 'SP',
          postalCode: '01232-000',
          addressCountry: 'BR',
        },
        contactPoint: {
          '@type': 'ContactPoint',
          contactType: 'customer service',
          telephone: '+5511942886720',
          areaServed: 'BR',
          availableLanguage: 'Portuguese',
        },
      },
      {
        '@type': 'WebSite',
        '@id': `${origin}/#website`,
        name: 'Qualidoc',
        url: siteUrl,
        inLanguage: 'pt-BR',
        publisher: { '@id': organizationId },
        potentialAction: {
          '@type': 'SearchAction',
          target: {
            '@type': 'EntryPoint',
            urlTemplate: `${absoluteUrl('/search')}?${encodeURIComponent(
              `${MAIN_SEARCH_INDEX_ID}[query]`,
            )}={search_term_string}`,
          },
          'query-input': 'required name=search_term_string',
        },
      },
    ],
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
    />
  );
}
